import type { Point, Stroke } from '../../types';

function distanceToLineSegment(point: Point, lineStart: Point, lineEnd: Point): number {
  const dx = lineEnd.x - lineStart.x;
  const dy = lineEnd.y - lineStart.y;
  const lengthSquared = dx * dx + dy * dy;

  if (lengthSquared === 0) {
    const px = point.x - lineStart.x;
    const py = point.y - lineStart.y;
    return Math.sqrt(px * px + py * py);
  }

  let t = ((point.x - lineStart.x) * dx + (point.y - lineStart.y) * dy) / lengthSquared;
  t = Math.max(0, Math.min(1, t));

  const closestX = lineStart.x + t * dx;
  const closestY = lineStart.y + t * dy;
  const distX = point.x - closestX;
  const distY = point.y - closestY;
  return Math.sqrt(distX * distX + distY * distY);
}

export function isPointNearStroke(stroke: Stroke, point: Point, threshold?: number): boolean {
  const baseThreshold = 15;
  const strokeRadius = stroke.baseWidth / 2;
  const effectiveThreshold = threshold ?? baseThreshold + strokeRadius;

  for (let j = 0; j < stroke.points.length; j++) {
    const p1 = stroke.points[j]!;
    const dx = point.x - p1.x;
    const dy = point.y - p1.y;
    if (Math.sqrt(dx * dx + dy * dy) <= effectiveThreshold) return true;

    if (j < stroke.points.length - 1) {
      const p2 = stroke.points[j + 1]!;
      if (distanceToLineSegment(point, p1, p2) <= effectiveThreshold) return true;
    }
  }
  return false;
}

export function getStrokeAtPoint(strokes: Stroke[], point: Point): { stroke: Stroke; index: number } | null {
  for (let i = strokes.length - 1; i >= 0; i--) {
    if (isPointNearStroke(strokes[i]!, point)) {
      return { stroke: strokes[i]!, index: i };
    }
  }
  return null;
}
